module.exports = __webpack_public_path__ + "img/photo_safety02.f1c87bb7.jpg";